var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { GlobalUser, GlobalUserIncludes } from '@/models/GlobalUser';
import { School } from '@/models/School';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Prop, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { avatarHtml } from '@/support/String';
let AddSchoolDialog = class AddSchoolDialog extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedSchools = [{ id: 'mygreatschool', name: 'Mygreatschool' }];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // protected created(): void {
    //   if (this.user && this.user.schools) {
    //     this.selectedSchools = this.user.schools;
    //   }
    // }
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
    }
    // #endregion
    // #region Async methods
    async update() {
        const payload = {
            schools: this.selectedSchools.map((school) => school.id),
        };
        const updatedUser = await this.user
            .include([GlobalUserIncludes.SCHOOLS])
            .update(payload)
            .catch((error) => {
            ErrorHandler.network(error);
            return null;
        });
        if (updatedUser) {
            this.$emit('created');
            this.close();
        }
    }
    // #endregion
    // #region Getters & Setters
    get tableVisibility() {
        return {
            limit: false,
        };
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('school.title', 1),
                plural: this.$tc('school.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$tc('name.title'),
                    value: 'name',
                    action: '/admin/schools/{id}',
                },
            ],
            actions: [],
            filters: [],
            model: new School(),
        };
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof GlobalUser !== "undefined" && GlobalUser) === "function" ? _a : Object)
], AddSchoolDialog.prototype, "user", void 0);
AddSchoolDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], AddSchoolDialog);
export default AddSchoolDialog;
